var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        {
          staticClass: "flex-wrap",
          attrs: { gutter: _vm.device === "mobile" ? 0 : 5, type: "flex" },
        },
        [
          _c(
            "el-col",
            { attrs: { md: 24, lg: 8 } },
            [
              _c(
                "el-card",
                {
                  staticStyle: { height: "390px" },
                  attrs: { shadow: "hover" },
                },
                [
                  _c("div", { staticClass: "mb-10 flex align-center" }, [
                    _c("b", { staticClass: "flex1 fs-a1" }, [
                      _c("span", { staticClass: "lin" }),
                      _vm._v("智能检测"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: _vm.device === "mobile" ? 5 : 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { md: 24, lg: 24 } },
                        [
                          _c(
                            "el-row",
                            {
                              attrs: {
                                gutter: _vm.device === "mobile" ? 5 : 10,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "pl-5 flex align-center" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/zljc.png"),
                                      width: "60",
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pl-10 flex" },
                                    [
                                      _c("div", { staticClass: "mb-5 mr-10" }, [
                                        _vm._v("设备智能检测"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "small",
                                            round: "",
                                            plain: "",
                                          },
                                        },
                                        [_vm._v("异常处理")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-tabs",
                                    {
                                      on: { "tab-click": _vm.handleClick },
                                      model: {
                                        value: _vm.activeName,
                                        callback: function ($$v) {
                                          _vm.activeName = $$v
                                        },
                                        expression: "activeName",
                                      },
                                    },
                                    [
                                      _c("el-tab-pane", {
                                        attrs: {
                                          label: "我的",
                                          name: "second",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-tab-pane", {
                                        attrs: { label: "下级", name: "third" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.abnormalInfo[_vm.abnormal_type],
                                function (item, index) {
                                  return _c(
                                    "el-col",
                                    {
                                      staticClass: "border",
                                      staticStyle: { padding: "0" },
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cursor flex",
                                          on: {
                                            click: function ($event) {
                                              return _vm.jump(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bg-f8 p-10 pl-15 pr-15 text-gray",
                                            },
                                            [_vm._v(_vm._s(item.name) + "：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "text-danger p-10" },
                                            [
                                              _c("count-to", {
                                                attrs: {
                                                  "start-val": 0,
                                                  "end-val": _vm.delComma(
                                                    item.num
                                                  ),
                                                  duration: 2600,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "mb-5 to-do", attrs: { md: 24, lg: 8 } },
            [
              _c(
                "el-card",
                {
                  staticStyle: { height: "390px" },
                  attrs: { shadow: "hover", "body-style": { padding: "10px" } },
                },
                [
                  _c("div", { staticClass: "flex align-center" }, [
                    _c("b", { staticClass: "flex1 fs-a1" }, [
                      _c("span", { staticClass: "lin" }),
                      _vm._v("待办事宜"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "mb-20 flex-wrap ",
                      attrs: { gutter: 10, type: "flex" },
                    },
                    _vm._l(_vm.toDo, function (item, index) {
                      return _c("el-col", { attrs: { md: 3, lg: 8 } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pt-10 pb-10 mt-10 to-item cursor border pl-5",
                            on: {
                              click: function ($event) {
                                _vm.$router.push({
                                  path:
                                    "" +
                                    (_vm.checkRoles(["terminal"])
                                      ? ""
                                      : item.url),
                                })
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "text-gray fs-s2" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: " fs-b2 mt-5",
                                style: { color: _vm.colorPalette[index] },
                              },
                              [_c("b", [_vm._v(_vm._s(item.num))])]
                            ),
                          ]
                        ),
                      ])
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", { attrs: { sm: 24, lg: 8 } }, [
            _c(
              "div",
              {
                staticClass: "bg-white pt-10 pl-20 pr-20 pb-20",
                staticStyle: { height: "390px" },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "pt-10 mb-10 flex align-center",
                    attrs: { to: "/home/article?type=1" },
                  },
                  [
                    _c("b", { staticClass: "flex1 fs-a1" }, [
                      _c("span", { staticClass: "lin" }),
                      _vm._v("最新公告"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-s2 text-gray" }, [
                      _vm._v("更多"),
                      _c("i", {
                        staticClass: "el-icon-arrow-right el-icon--right",
                      }),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "marquee_box fs-s2 text-left",
                    class: { "f-h": _vm.toDo.length == 0 },
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "marquee_list",
                        class: {
                          marquee_top: _vm.marquee_top && _vm.toDo.length > 0,
                        },
                      },
                      _vm._l(_vm.articleList, function (item) {
                        return _c(
                          "li",
                          { staticClass: "text-cut" },
                          [
                            _c(
                              "el-link",
                              {
                                staticClass: "text-cut block",
                                attrs: { underline: false },
                                on: {
                                  click: function ($event) {
                                    return _vm.getDetail(item)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "mr-10" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.parseTime(
                                        item.add_date,
                                        "{y}-{m}-{d} {h}:{i}"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(item.title))]),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.info.title, visible: _vm.detailVisible },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c("div", {
            staticClass: "max-w bg-gray",
            domProps: { innerHTML: _vm._s(_vm.info.content) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }